import { CihTabNav } from "~/components/cih/tab-nav";

import type { CoachSectionNumbers } from "./section-numbering";

type Props = {
  sectionNumbers: CoachSectionNumbers;
  testimonialCount: number;
  credentialCount: number;
};

// CihTabNav suppresses tabs where `count === 0` and renders a numeric badge
// when `count` is a number. For binary-presence sections (About / Helps with
// / Outcomes / Approach / Coaching) we want the tab visible without a badge,
// so we either pass `count: undefined` (visible, no pill) or omit the entry
// entirely when absent.
type Tab = { id: string; label: string; count?: number };

export function CoachTabNav({
  sectionNumbers,
  testimonialCount,
  credentialCount,
}: Props) {
  const tabs: Tab[] = [];
  if (sectionNumbers.about !== undefined)
    tabs.push({ id: "about", label: "About" });
  if (sectionNumbers.helpsWith !== undefined)
    tabs.push({ id: "helps-with", label: "Helps with" });
  if (sectionNumbers.outcomes !== undefined)
    tabs.push({ id: "outcomes", label: "Outcomes" });
  if (sectionNumbers.approach !== undefined)
    tabs.push({ id: "approach", label: "Approach" });
  if (sectionNumbers.coaching !== undefined)
    tabs.push({ id: "coaching", label: "Coaching" });
  if (credentialCount > 0) {
    tabs.push({
      id: "credentials",
      label: "Credentials",
      count: credentialCount,
    });
  }
  if (testimonialCount > 0) {
    tabs.push({
      id: "testimonials",
      label: "Testimonials",
      count: testimonialCount,
    });
  }

  if (tabs.length < 4) return null;

  return <CihTabNav tabs={tabs} />;
}
